<script setup lang="ts">
import AppEnvironmentNotice from '@/components/app-shell/AppEnvironmentNotice.vue'
import AppImpersonationNotice from '@/components/app-shell/AppImpersonationNotice.vue'
</script>

<template>
  <div class="flex h-full w-full flex-col">
    <div class="flex w-full items-start justify-center p-12">
      <Link href="/">
        <img src="@assets/images/logo.svg" alt="FinEstHub" class="h-11 max-w-none shrink-0" />
      </Link>
    </div>
    <AppEnvironmentNotice class="mb-4" />
    <AppImpersonationNotice class="mb-4" />
    <div class="min-h-0 flex-1 overflow-y-auto">
      <slot />
    </div>
    <slot name="footer" />
  </div>
</template>
